import Modal from "./modal";

export default class StartTrialModal extends Modal {
  constructor() {
    super("start-trial-modal");
    this.$form = document.getElementById("start-trial-modal");
    this.goToButton = document.getElementById("goToSubscriptions");
    this.goToButton.addEventListener("click", this.goToSubscriptions);
    this.cb = null;
  }
  goToSubscriptions = () => {
    peque.navigation.browse(window.currentCompany.subscriptionUrl);
  }

}